import React from "react";
import {
  Route,
  Switch,
  useRouteMatch,
  NavLink as Links,
} from "react-router-dom";
import Error404 from "../../Components/Error404";
import Tables from "./Tables";
import TableGroup from "./TableGroup";
export default function Table() {
  const { url } = useRouteMatch();
  return (
    <div className="p-0 m-0">
      <header className="header no-border">
        <div className="header-info">
          <div className="left">
            <h2 className="header-title">
              <strong>Table Management</strong>
              <small className="subtitle">
                Here you can edit,delete,view Table.
              </small>
            </h2>
          </div>
        </div>
        <div className="header-action">
          <nav className="nav">
            <Links className="nav-link" activeClassName="active" to={`${url}`}>
              Table
            </Links>
            <Links
              className="nav-link"
              activeClassName="active"
              to={`${url}/TableGroup`}
            >
              Table Group
            </Links>
          </nav>
        </div>
      </header>

      <Switch>
        <Route path={url} exact component={Tables} />
        <Route path={`${url}/TableGroup`} exact component={TableGroup} />
        <Route path="*">
          <Error404 />
        </Route>
      </Switch>
    </div>
  );
}
